import { getBifrost } from "../services/bifrost.service";

export function useSystemStatus() {
  const { data: systemStatus } = getBifrost().systemStatus__server__get.useServer({});

  return systemStatus;
}
